import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CategorySelection, parseCategoryParam, serializeCategoryParam } from '../utils/serviceCategories';

export const CATEGORY_PARAM = 'categories';

/**
 * The service-category selection, kept in the URL (`?categories=A,B`) so it survives drilling
 * from the team table into a staff page and back, and can be shared as a link. Absent = every category.
 */
export function useServiceCategoryFilter(): { selected: CategorySelection; setSelected: (next: CategorySelection) => void } {
  const [params, setParams] = useSearchParams();
  const raw = params.get(CATEGORY_PARAM);
  const selected = useMemo(() => parseCategoryParam(raw), [raw]);

  const setSelected = useCallback(
    (next: CategorySelection) => {
      const copy = new URLSearchParams(params);
      const value = serializeCategoryParam(next);
      if (value === null) copy.delete(CATEGORY_PARAM);
      else copy.set(CATEGORY_PARAM, value);
      setParams(copy, { replace: true });
    },
    [params, setParams]
  );

  return { selected, setSelected };
}
